export default "__VITE_ASSET__gx$bGyQx__"